import { render, staticRenderFns } from "./WebsiteTitle.vue?vue&type=template&id=cbf61868&scoped=true&"
import script from "./WebsiteTitle.vue?vue&type=script&lang=js&"
export * from "./WebsiteTitle.vue?vue&type=script&lang=js&"
import style0 from "./WebsiteTitle.vue?vue&type=style&index=0&id=cbf61868&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf61868",
  null
  
)

export default component.exports